import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import classnames from 'classnames';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import styled from '@emotion/styled';

interface IProps {
    isOpen: boolean;
    toogleStateOpen(isOpen): void;
}

const TextCollapsibleStyled = styled.span`
    font-size: 14px;
    color: ${({ theme }) => theme.link.primary};
    margin-top: 0;
    display: flex;
    align-items: center;
    cursor: pointer;

    svg {
        fill: ${({ theme }) => theme.link.primary};
        margin-left: 6px;
    }

    .rotate {
        transform-box: fill-box;
        transform-origin: center;
        transform: rotate(180deg);
    }
`;

export function TextCollapsible({ isOpen, toogleStateOpen }: IProps) {
    return (
        <TextCollapsibleStyled onClick={() => toogleStateOpen(!isOpen)}>
            {isOpen ? __('load less', 'dreamlines') : __('load more', 'dreamlines')}
            <ArrowDownIcon className={classnames({ rotate: isOpen })} width={14} />
        </TextCollapsibleStyled>
    );
}
